import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, HomeIcon, TimerIcon, TrophyIcon, UsersIcon } from 'lucide-react';
export type ViewTab = 'floor' | 'home' | 'reports' | 'leaderboard' | 'users';
const tabs: {
  id: ViewTab;
  label: string;
  Icon: typeof UsersIcon;
}[] = [{
  id: 'floor',
  label: 'Floor Time',
  Icon: TimerIcon
}, {
  id: 'home',
  label: 'Home',
  Icon: HomeIcon
}, {
  id: 'reports',
  label: 'Reports',
  Icon: BarChart3Icon
}, {
  id: 'leaderboard',
  label: 'Leaderboard',
  Icon: TrophyIcon
}, {
  id: 'users',
  label: 'Users',
  Icon: UsersIcon
}];
interface NavTabsProps {
  value: ViewTab;
  onChange: (tab: ViewTab) => void;
}
export function NavTabs({
  value,
  onChange
}: NavTabsProps) {
  const onKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const next = (index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    onChange(tabs[next].id);
    document.getElementById(`tab-${tabs[next].id}`)?.focus();
  };
  return <div role="tablist" aria-label="Calls Insight Hub views" className="flex items-center gap-1" data-id="element-380" data-mp="1sn71d7a0c6xh">
      {tabs.map(({
      id,
      label,
      Icon
    }, i) => {
      const active = id === value;
      return <button key={id} id={`tab-${id}`} type="button" role="tab" aria-selected={active} aria-controls={`panel-${id}`} tabIndex={active ? 0 : -1} onClick={() => onChange(id)} onKeyDown={e => onKeyDown(e, i)} className={`relative flex items-center gap-2 whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${active ? 'text-on-accent' : 'text-muted hover:bg-canvas hover:text-ink'}`} data-id="element-381" data-mp="1nu4f7k7k7zrb" data-mpi={i}>
            {active && <motion.span layoutId="nav-pill" className="absolute inset-0 rounded-xl bg-accent" transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-382" data-mp="2z6x4mocvoc47" />}
            <Icon className="relative h-4 w-4" aria-hidden data-id="element-383" data-mp="2ntenpo7fcvfp" />
            <span className="relative" data-id="element-384" data-mp="2nw0v9nubfaxx">{label}</span>
          </button>;
    })}
    </div>;
}